import { HomeRoofIcon } from './HomeRoofIcon';

/**
 * author: Michael Irigoyen
 * id 32EF139A-14EB-4767-ADDD-08120FB530A0
 * name home-roof
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-roof.svg
 * tags
 * - Home Automation 
 */
export const HouseAtticIcon = HomeRoofIcon;
export default HouseAtticIcon